import React from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { hooks, models } from '@vote4dance/judging-sdk';
import { Loading } from '../../../../../base-react/components/Loading';
import { groupBy } from '../utilities';
import { Space, Table, Typography } from 'antd';
var Stream = hooks.streams.Stream;
var CheckinResultSource = models.checkins.CheckinResultSource;
var TeamItem = models.teams.TeamItem;
import { WarningOutlined } from '@ant-design/icons';
const { Text } = Typography;
export const CheckinReport = (props) => {
    const { competition_id } = props;
    const [results, loading] = Stream(CheckinResultSource(competition_id));
    if (loading) {
        return React.createElement(Loading, null);
    }
    const getFilteredTeams = () => {
        if (!results)
            return [];
        // Only consider teams that have a checkin_at timestamp and defined team_id.
        const filteredResults = results.filter((team) => team.checkin_at != null && team.team_id != null);
        // Group teams by team_id.
        const groupedTeams = groupBy(filteredResults, team => team.team_id);
        // For each group, decide what to return.
        // If the team has different checkin_result values, return all records (marked with difference: true).
        // Otherwise, return just the first record (if checkin_status > 0) with difference: false.
        const filteredTeams = Object.values(groupedTeams).flatMap(teamGroup => {
            const resultSet = new Set(teamGroup.map(team => team.checkin_result));
            const hasDifferentResults = resultSet.size > 1;
            if (hasDifferentResults) {
                return teamGroup.map(team => ({ ...team, difference: true }));
            }
            else {
                const team = teamGroup[0];
                // Check if checkin_status is defined and greater than zero.
                return (typeof team.checkin_status === 'number' && team.checkin_status > 0)
                    ? { ...team, difference: false }
                    : [];
            }
        });
        return filteredTeams;
    };
    const columns = [
        {
            title: _T('team.details.team_start_number.short'),
            dataIndex: 'team_start_number'
        },
        {
            dataIndex: "team_name",
            title: _T('team.details.team_name.label'),
            render: (text, item) => TeamItem.getFullName(item)
        },
        {
            dataIndex: "team_class",
            title: _T('class.title')
        },
        {
            title: _T('team.details.team_org.label'),
            dataIndex: 'team_org'
        },
        {
            title: _T('checkin.status.label'),
            dataIndex: 'checkin_result',
            render: (text, item) => (React.createElement(Space, null,
                _T('checkin.status.' + text),
                item.difference && React.createElement(Text, { type: "danger" },
                    React.createElement(WarningOutlined, null),
                    " ",
                    _T('checkin.status.different'))))
        }
    ].filter(column => Object.keys(column).length > 0);
    const getRowKey = (record) => { var _a, _b, _c; return `${record.team_id}-${(_a = record.checkin_result) !== null && _a !== void 0 ? _a : 'unknown'}-${(_b = record.checkin_at) !== null && _b !== void 0 ? _b : ''}-${(_c = record.checkin_status) !== null && _c !== void 0 ? _c : ''}`; };
    return (React.createElement(Table, { columns: columns, dataSource: getFilteredTeams(), pagination: false, size: "small", rowKey: getRowKey }));
};
